import { useEffect, useState } from 'react';
import { getIconFileName } from '../utils/iconUtils';

const cache = new Map();
function loadIcon(source) {
  if (!cache.has(source)) cache.set(source, new Promise(resolve => {
    const image = new Image();
    image.onerror = () => resolve({ source, ratio: 2 });
    image.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0);
        const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
        let left = canvas.width, top = canvas.height, right = -1, bottom = -1;
        for (let y = 0; y < canvas.height; y++) {
          for (let x = 0; x < canvas.width; x++) {
            if (pixels[(y * canvas.width + x) * 4 + 3] > 10) {
              left = Math.min(left, x); right = Math.max(right, x);
              top = Math.min(top, y); bottom = Math.max(bottom, y);
            }
          }
        }
        if (right < left) return resolve({ source, ratio: 2 });
        const width = right - left + 1, height = bottom - top + 1;
        canvas.width = width;
        canvas.height = height;
        context.drawImage(image, left, top, width, height, 0, 0, width, height);
        resolve({ source: canvas.toDataURL(), ratio: width / height });
      } catch (_) {
        resolve({ source, ratio: image.naturalWidth / image.naturalHeight || 2 });
      }
    };
    image.src = source;
  }));
  return cache.get(source);
}

export function useTrimmedSeriesIcons(seasons) {
  const key = JSON.stringify(seasons.map(name =>
    `${process.env.PUBLIC_URL}/assets/series-icons/${getIconFileName(name)}.png`));
  const [icons, setIcons] = useState({});
  useEffect(() => {
    let active = true;
    const sources = JSON.parse(key);
    Promise.all(sources.map(loadIcon)).then(results => {
      if (active) setIcons(Object.fromEntries(sources.map((source, index) => [source, results[index]])));
    });
    return () => { active = false; };
  }, [key]);
  return JSON.parse(key).map(source => icons[source] || { source, ratio: 2 });
}
